import { AxiosPromise } from "axios";
import { axiosInstance } from "../instance";
import { ICreatedSkills, ICreateSkillRequest } from "./types";

export const createSkill = (
  params: ICreateSkillRequest
): AxiosPromise<ICreatedSkills[]> =>
  axiosInstance.post(`/skill/create`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
